import { SEO } from '../../components/SEO'
import { useState, useRef, useEffect, useMemo } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { 
  BookOpen, ChevronRight, Home, Rocket, Settings, Shield, 
  HelpCircle, FileText, Search, X
} from 'lucide-react'
import { Link, useNavigate, useLocation } from 'react-router-dom'

// 闁诲海鏁搁崢褔宕ｉ崱娑樿Е闁告洦浜崵瀣磼閺冨倸鞋濠碘槅鍘剧槐鎺楀礋椤忓拋鍋?
import InstallGuide from './sections/InstallGuide'
import BasicUsage from './sections/BasicUsage'
import ModelConfig from './sections/ModelConfig'
import SmartChat from './sections/SmartChat'
import TaskExecution from './sections/TaskExecution'
import KnowledgeBase from './sections/KnowledgeBase'
import CustomInstructions from './sections/CustomInstructions'
import MemoryManagement from './sections/MemoryManagement'
import PermissionManagement from './sections/PermissionManagement'
import Troubleshooting from './sections/Troubleshooting'

const Manual = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [activeSection, setActiveSection] = useState('install-guide')
  const [searchQuery, setSearchQuery] = useState('')
  const [showSearchResults, setShowSearchResults] = useState(false)
  const sidebarRef = useRef(null)
  const searchInputRef = useRef(null)

  // 婵犮垼娉涚€氼噣骞?URL hash 闁荤姴鎼悿鍥?
  useEffect(() => {
    const hash = location.hash.replace('#', '')
    if (hash) {
      setActiveSection(hash)
    }
  }, [location.hash])

  // 闂佺儵鏅╅崰鏍礊瀹ュ洨纾奸柟鎯ь嚟閳?
  const manualSections = [
    {
      id: 'getting-started',
      icon: Rocket,
      title: 'Quick Start',
      color: 'from-blue-500 to-cyan-500',
      items: [
        { id: 'install-guide', name: 'Install Guide', component: InstallGuide },
        { id: 'basic-usage', name: 'Basic Usage', component: BasicUsage },
        { id: 'model-config', name: 'Model Config', component: ModelConfig },
      ]
    },
    {
      id: 'features',
      icon: Settings,
      title: 'Feature Guides',
      color: 'from-purple-500 to-pink-500',
      items: [
        { id: 'smart-chat', name: 'Smart Chat', component: SmartChat },
        { id: 'task-execution', name: 'Task Execution', component: TaskExecution },
        { id: 'knowledge-base', name: 'Knowledge Base', component: KnowledgeBase },
        { id: 'custom-instructions', name: 'Custom Instructions', component: CustomInstructions },
        { id: 'memory-management', name: 'Memory Management', component: MemoryManagement },
      ]
    },
    {
      id: 'advanced',
      icon: Shield,
      title: 'Advanced',
      color: 'from-green-500 to-teal-500',
      items: [
        { id: 'permission-management', name: 'Permission Management', component: PermissionManagement },
      ]
    },
    {
      id: 'faq',
      icon: HelpCircle,
      title: 'FAQ',
      color: 'from-orange-500 to-red-500',
      items: [
        { id: 'troubleshooting', name: 'Troubleshooting', component: Troubleshooting },
      ]
    }
  ]

  // 闂佸搫顑呯€氼剛绱撻幘璇茬婵犲﹤鎳庨崑宥囩磼娓氬灝鐏╃紒?
  const searchIndex = useMemo(() => {
    const index = []
    manualSections.forEach(section => {
      section.items.forEach(item => {
        // 闂佸憡甯楃粙鎴犵磽閹惧鈻旈悗娑櫳戦ˇ褔鎮楅崷顓熷殌婵炲懏甯″鍫曞Ψ閿曚緡娲梺鍝勬湰閹稿墽鍒掑鍡欘浄閻犳椽缂氱€氭瑩鏌熺紒妯哄鐟滄澘娲顒勫炊閵婏附瀚?
        const Component = item.component
        const tempDiv = document.createElement('div')
        
        // 缂備胶濮崑鎾绘煕閺嶃劎澧辨繛鍫熷灴瀵剟宕堕妸锔藉闂佸湱绮崝鏇°亹?- 闂佺硶鏅炲銊ц姳椤掑倻纾奸柛鏇ㄤ簼椤愪粙鏌涘顒傂ょ悮銊╂煕濠婂啰鐏遍柣婵堝厴閹崇偤宕掑☉姘伇婵?
        index.push({
          id: item.id,
          name: item.name,
          sectionTitle: section.title,
          // 闁哄鏅滈悷鈺呭闯閻戣棄鐭楁い鏍ㄧ懁缁ㄧ増绻涢敐鍫殭濠殿喚鍋ゅ鎾级閹搭厽鈻奸梺绋跨箲婵炲﹪寮鐘冲珰?
          keywords: [item.name, section.title].join(' ').toLowerCase()
        })
      })
    })
    return index
  }, [manualSections])

  // 闂佺懓鍚嬬划搴ㄥ磼閵娾晛绀夐柣鏃囶嚙閸?
  const searchResults = useMemo(() => {
    if (!searchQuery.trim()) return []
    
    const query = searchQuery.toLowerCase().trim()
    return searchIndex.filter(item => 
      item.keywords.includes(query) || 
      item.name.toLowerCase().includes(query) ||
      item.sectionTitle.toLowerCase().includes(query)
    )
  }, [searchQuery, searchIndex])

  // 閻熸粎澧楄ぐ绔巘iveSection闂佽　鍋撻柣鐔告緲缂嶄線鏌￠崘顓у晣缂佽鲸绻傞…銊ヮ潩椤掆偓琚熸繛鎾寸殰閸℃瑧褰鹃梺鍝勭Т缁绘劙宕虹仦淇变簻闁割偅娲栭崝?
  useEffect(() => {
    if (sidebarRef.current) {
      sidebarRef.current.scrollTop = 0
    }
  }, [activeSection])

  // 婵犮垼娉涚€氼噣骞冩繝鍥х婵犲﹤鎳庨崑宥嗕繆濡も偓濡盯宕濆澶嬪€?
  useEffect(() => {
    if (searchQuery.trim()) {
      setShowSearchResults(true)
    } else {
      setShowSearchResults(false)
    }
  }, [searchQuery])

  // 闂佺粯鍔楅幊鎾诲吹椤旇棄绶為柡宥庡幖閸斻儵鏌涜箛鏂库枙婵☆偅鎸抽獮鏍ь煥閸涱厼浜剁紓鍌欑劍閹稿鎮?
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchInputRef.current && !searchInputRef.current.contains(event.target)) {
        setShowSearchResults(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  // 婵犮垼娉涚€氼噣骞冩繝鍥ㄥ殨婵犲﹤鍟粈瀣煟閹邦喗鍤€闁搞値鍠楃粋宥団偓锝傛櫆椤?
  const handleSectionClick = (sectionId) => {
    setActiveSection(sectionId)
    setSearchQuery('')
    setShowSearchResults(false)
    // 濠电姴锕ラ懝鐐叏閳哄倶浜滈柣銏犳啞濡椼劌鈽夐幘璇″敽缂傚秴顑夊畷姘濞ｎ兘鍋撴繝鍥ㄧ劸?
    window.scrollTo(0, 0)
  }

  // 婵犮垼娉涚€氼噣骞冩繝鍥х婵犲﹤鎳庨崑宥囩磽娴ｈ灏伴柣蹇擃樀閹瑩鎮烽弶鎸庣槚
  const handleSearchResultClick = (sectionId) => {
    handleSectionClick(sectionId)
  }

  // 濠电偞鎸搁幊鎰板煘閺嶎厼绠规繝濠傛噹閸?
  const clearSearch = () => {
    setSearchQuery('')
    setShowSearchResults(false)
  }

  // 闂佸吋鍎抽崲鑼躲亹閸ヮ亗浜归柟鎯у暱椤ゅ懏绻濈喊妯轰壕濠电偠灏畷闈涒枔閹寸姷纾奸柛鏇ㄤ簼椤?
  const getCurrentComponent = () => {
    for (const section of manualSections) {
      const item = section.items.find(i => i.id === activeSection)
      if (item) return item.component
    }
    return InstallGuide
  }

  const CurrentComponent = getCurrentComponent()

  return (
    <>
      <SEO />
    <div className="manual-shell-dark pt-20 min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {/* 闂傚倸鐗勯崹鍦偓鍨焽娴狅箓骞嬪┑鎰闂?*/}
        <div className="flex items-center space-x-2 text-sm text-gray-400 mb-6">
          <Link to="/" className="hover:text-accent-cyan transition-colors flex items-center">
            <Home size={16} className="mr-1" />
            婵☆偓绲鹃悧鐘诲Υ?
          </Link>
          <ChevronRight size={16} />
          <Link to="/docs" className="hover:text-accent-cyan transition-colors">
            闂佸搫鍊稿ú锕傚Υ閸屾稓鈻旀い鎾跺仧婵?
          </Link>
          <ChevronRight size={16} />
          <span className="text-white">闂佹椿娼块崝宥夊春濞戙垹绠ラ悗锝庝簻閺傗偓</span>
        </div>

        {/* 婵＄偑鍊楅弫璇差焽娴兼潙鍐€闁搞儺鍓﹂弳?*/}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 flex items-center">
            <BookOpen className="mr-3 text-accent-cyan" size={36} />
            Avelia 闂佹椿娼块崝宥夊春濞戙垹绠ラ悗锝庝簻閺傗偓
          </h1>
          <p className="text-lg text-gray-400">
            闁诲海鎳撻張顒勫汲閿濆鍎嶉柛鏇ㄤ簻閳诲繘鏌ｉ～顒€濡介悗鍨哺瀹曗€澄旂€ｎ剛顦梺鍛婃煛閺呮瑧绱炲Ο璺ㄧ杸妞ゆ劧鑵归崑鎾绘偄閸撲胶鎲梺?Avelia
          </p>
        </motion.div>

        {/* 闂佺懓鍚嬬划搴ㄥ磼閵娿儺娴?*/}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mb-8 relative"
          ref={searchInputRef}
        >
          <div className="relative max-w-xl">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
            <input
              type="text"
              placeholder="闂佺懓鍚嬬划搴ㄥ磼閵娾晛妫橀柛銉ｅ妸閳ь剙鍊垮畷姗€宕ㄩ褍鏅?.."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onFocus={() => searchQuery.trim() && setShowSearchResults(true)}
              className="w-full pl-12 pr-12 py-3 glass-effect rounded-xl border border-white/10 focus:border-accent-cyan/50 outline-none transition-all"
            />
            {searchQuery && (
              <button
                onClick={clearSearch}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white transition-colors"
              >
                <X size={20} />
              </button>
            )}
          </div>

          {/* 闂佺懓鍚嬬划搴ㄥ磼閵娧呯＜闁规儳顕禍顖氣槈閹炬剚鍎愬┑顖氭惈椤?*/}
          <AnimatePresence>
            {showSearchResults && searchQuery.trim() && (
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                className="absolute top-full mt-2 w-full max-w-xl glass-effect rounded-xl border border-white/10 shadow-2xl z-50 max-h-96 overflow-y-auto"
              >
                {searchResults.length > 0 ? (
                  <div className="p-2">
                    <div className="text-xs text-gray-400 px-3 py-2">
                      闂佺懓鐏氶崕鎶藉春?{searchResults.length} 婵炴垶鎼╂禍鐐靛垝閵娾晛鍑?
                    </div>
                    {searchResults.map((result) => (
                      <button
                        key={result.id}
                        onClick={() => handleSearchResultClick(result.id)}
                        className="w-full text-left px-4 py-3 rounded-lg hover:bg-white/5 transition-colors group"
                      >
                        <div className="flex items-center justify-between">
                          <div>
                            <div className="text-sm font-medium text-white group-hover:text-accent-cyan transition-colors">
                              {result.name}
                            </div>
                            <div className="text-xs text-gray-400 mt-1">
                              {result.sectionTitle}
                            </div>
                          </div>
                          <ChevronRight size={16} className="text-gray-400 group-hover:text-accent-cyan transition-colors" />
                        </div>
                      </button>
                    ))}
                  </div>
                ) : (
                  <div className="p-6 text-center text-gray-400">
                    <Search size={32} className="mx-auto mb-2 opacity-50" />
                    <p className="text-sm">No matching content found.</p>
                    <p className="text-xs mt-1">Try another keyword.</p>
                  </div>
                )}
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 lg:gap-8">
          {/* 婵炴挻鐨滈崱娆戝骄闂佸搫绉寸换鎺懨洪幏灞讳汗?*/}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 }}
            className="lg:col-span-1"
          >
            <div ref={sidebarRef} className="glass-effect rounded-xl p-4 sticky top-24 max-h-[calc(100vh-120px)] overflow-y-auto">
              <h3 className="text-sm font-semibold text-gray-400 mb-4 flex items-center">
                <FileText size={16} className="mr-2" />
                闂佺儵鏅╅崰鏍礊瀹ュ洠鍋撴担鍐棈闁?
              </h3>
              <nav className="space-y-4">
                {manualSections.map((section) => (
                  <div key={section.id}>
                    <div className="flex items-center space-x-2 text-xs font-semibold text-gray-500 mb-2">
                      <section.icon size={14} />
                      <span>{section.title}</span>
                    </div>
                    <ul className="space-y-1 ml-5 border-l border-white/10">
                      {section.items.map((item) => (
                        <li key={item.id}>
                          <button
                            onClick={() => handleSectionClick(item.id)}
                            className={`block w-full text-left px-3 py-2 text-sm rounded-lg transition-all ${
                              activeSection === item.id
                                ? 'bg-gradient-to-r from-accent-purple/20 to-accent-cyan/20 text-white font-medium border-l-2 border-accent-cyan'
                                : 'text-gray-400 hover:text-white hover:bg-white/5'
                            }`}
                          >
                            {item.name}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </nav>
            </div>
          </motion.div>

          {/* 婵炴垶鎹侀褔宕€电硶鍋撻崷顓熷殌閻?*/}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="lg:col-span-3"
          >
            <div className="glass-effect rounded-xl p-6 sm:p-8 md:p-10">
              <CurrentComponent />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Manual
